import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateOrUpdateNonProjectInvoiceData,
	UpdateDraftInvoiceStatusToSentData,
	UpdateNonProjectInvoiceStatusToSentData,
} from "~/modules/billing/api/draftInvoice/draftInvoiceTypes.ts";
import type { UnprocessedInvoicesIndexResponse } from "~/modules/billing/api/unprocessedInvoicesTypes.ts";

const draftInvoicesBasePath = "/invoices/draft";

export function indexDraftInvoices(): AxiosApiResponsePromise<UnprocessedInvoicesIndexResponse> {
	return axiosApi.get(draftInvoicesBasePath);
}

export function createNonProjectInvoice(invoiceData: CreateOrUpdateNonProjectInvoiceData): AxiosApiResponsePromise<{
	newInvoiceId: string;
}> {
	return axiosApi.post(`${draftInvoicesBasePath}/non-project`, invoiceData);
}

export function createAdvanceProjectInvoice(invoiceData: {
	comment:string|null;
	deliveryEndDate: string;
	deliveryStartDate: string;
	projectId: string;
	orderId:string;
	subtotalCents: number;
	vatPercentage: number;
}): AxiosApiResponsePromise<{
	newInvoiceId: string;
}> {
	return axiosApi.post(`${draftInvoicesBasePath}/advance-invoice`, invoiceData);
}

export function updateNonProjectInvoice(invoiceId: string,
	invoiceData: CreateOrUpdateNonProjectInvoiceData): AxiosApiResponsePromise<{
	newInvoiceId: string;
}> {
	return axiosApi.put(`${draftInvoicesBasePath}/non-project/${invoiceId}`, invoiceData);
}

export function updateDraftInvoiceStatusToSent(
	invoiceId: string,
	data: UpdateDraftInvoiceStatusToSentData,
): AxiosApiResponsePromise<string> {
	return axiosApi.patch(`${draftInvoicesBasePath}/${invoiceId}/status/sent`, data);
}

export function updateDraftNonProjectInvoiceStatusToSent(
	invoiceId: string,
	data: UpdateNonProjectInvoiceStatusToSentData,
): AxiosApiResponsePromise<string> {
	return axiosApi.patch(`${draftInvoicesBasePath}/non-project/${invoiceId}/status/sent`, data);
}

export function deleteDraftNonProjectInvoice(
	invoiceId: string,
): AxiosApiResponsePromise<string> {
	return axiosApi.delete(`${draftInvoicesBasePath}/non-project/${invoiceId}`);
}

export function revertDraftInvoiceStatusToPending(
	invoiceId: string,
): AxiosApiResponsePromise<string> {
	return axiosApi.patch(`${draftInvoicesBasePath}/${invoiceId}/status/pending`);
}

export function updateTimeTrackingsEditableStatus(
	invoiceId: string,
	timeTrackingsEditable: boolean,
): AxiosApiResponsePromise<string> {
	return axiosApi.patch(`${draftInvoicesBasePath}/${invoiceId}/time-trackings-editable-status`, { timeTrackingsEditable });
}